export default function VacantPropertyReviewMembership() {
    return (
<div>
<h4>Members</h4>
<hr/>
                <p>
                <b>James Dillon</b>&nbsp;<i>Borough Manager</i>
                </p>
                <p>
                <b>Jeff Darwak</b>&nbsp;<i>Bucks Co. Redevelopment Authority</i>
                </p>
                <p>
                <b>Helen Hlahol</b>&nbsp;<i>Council President</i>
                <br/>
                Term Expires: January 2030
                </p>
                <p>
                <b>Gary Wallace</b>&nbsp;<i>Mayor</i>
                <br/>
                Term Expires: January 2030
                </p>
                <p>
                <b>Don Diretto</b>&nbsp;<i>Planning Commission</i>
                <br/>
                Term Expires: December 2028
                </p>
</div>
    )
}
